/** Links do desenvolvedor exibidos no rodapé. */
export const developerCredit = {
  name: 'Rafael Oliveira',
  tagline: 'Quer um site profissional como este? Fale comigo.',
  instagram: 'https://www.instagram.com/raffaa.olv',
  linkedin:
    'https://www.linkedin.com/in/rafael-oliveira-42922a219',
  contact: 'https://wa.me/5511945626252',
}
